import { render } from "./twitter.vue?vue&type=template&id=2971aa36"
const script = {}

import exportComponent from "/usr/local/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__